// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"349":"email-editor","552":"chartjs","714":"markdown-editor"}[chunkId] || chunkId) + "-" + {"94":"34c46dca33419b7a7fc4","349":"61345c61c8ad81262b4d","492":"47e0a8330d09ad957eb6","552":"3381fca3364e2e8aeb57","714":"98f0a9f8848086b80a26","818":"2dffd46d1b653aba56b3"}[chunkId] + ".chunk.js";
};